function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6359ba8f\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_globals.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_colors.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_fonts.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_variables.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_mixins.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_functions.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExplodedImage.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExplodedImage.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExplodedImage.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6359ba8f\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExplodedImage.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6359ba8f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ExplodedImage.vue
// module id = null
// module chunks = 